import React from 'react';
import { normalizeWorkspaceRole, roleLabel } from '../../../../../utils/workspaceAccess';
import { initialsFor, presentMember } from '../utils/peopleUtils';

export function MemberRow({
  member,
  currentUser,
  showEmails,
  mayChangeRoles,
  mayRemove,
  busyMemberId,
  confirmRemoveId,
  onRoleChange,
  onRemove,
  onAskRemove,
  onKeep,
}) {
  const shown = presentMember(member, currentUser);
  const role = normalizeWorkspaceRole(member.role);
  const canEditThis = role !== 'owner' && !shown.isYou && (mayChangeRoles || mayRemove);
  const memberBusy = busyMemberId === member.userId;
  const confirming = confirmRemoveId === member.userId;

  return (
    <li className="settings-people__row">
      <span className="settings-people__avatar" aria-hidden="true">
        {initialsFor(shown.email || shown.name)}
      </span>
      <div className="settings-people__who">
        <span className="settings-people__name">{shown.name}</span>
        {(showEmails || shown.isYou) && shown.email && (
          <span className="settings-people__sub">{shown.email}</span>
        )}
      </div>
      {confirming ? (
        <div className="settings-people__row-end">
          <span className="settings-people__confirm">Remove?</span>
          <button
            type="button"
            className="settings-people__link settings-people__link--danger"
            disabled={memberBusy}
            onClick={() => onRemove(member)}
          >
            {memberBusy ? 'Removing…' : 'Yes, remove'}
          </button>
          <button
            type="button"
            className="settings-people__link"
            disabled={memberBusy}
            onClick={onKeep}
          >
            Keep
          </button>
        </div>
      ) : (
        <div className="settings-people__row-end">
          {mayChangeRoles && canEditThis ? (
            <select
              className="settings-people__field settings-people__select settings-people__select--role"
              value={role === 'admin' ? 'admin' : 'user'}
              disabled={memberBusy}
              aria-label={`Role for ${shown.name}`}
              onChange={(e) => onRoleChange(member, e.target.value)}
            >
              <option value="admin">Admin</option>
              <option value="user">Member</option>
            </select>
          ) : (
            <span className="settings-people__role">{roleLabel(member.role)}</span>
          )}
          {mayRemove && canEditThis && (
            <button
              type="button"
              className="settings-people__link settings-people__link--danger"
              onClick={() => onAskRemove(member.userId)}
            >
              Remove
            </button>
          )}
        </div>
      )}
    </li>
  );
}
